import { Container, Grid } from "@mui/material";
import { Divider } from "antd";
import React, { Component } from "react";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { PostData } from "../api/service";
import { Typography } from "@material-ui/core";

const handleDragStart = (e) => e.preventDefault();

export default class HightlightShort extends Component {
  state = {
    loadedData: [],
    isLoaded: false,
  };

  componentDidMount() {
    PostData(`/getphotosforwebsitewithcaption`, {
      type: this.props.type,
    }).then((resp) => {
      this.setState({
        loadedData: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    // When currentYearOnly is set (home page gallery), show only images whose
    // event caption contains the current year (e.g. "... (15.03.2026)").
    // The real event year lives in the caption, not in a stored field.
    const currentYear = String(new Date().getFullYear());
    let displayData = this.props.currentYearOnly
      ? this.state.loadedData.filter((el) =>
          (el.caption || "").includes(currentYear)
        )
      : this.state.loadedData;

    // When oneImagePerEvent is set (home page gallery), show only the first
    // image of each event (grouped by caption) so distinct events appear
    // instead of many photos of the same event.
    if (this.props.oneImagePerEvent) {
      const seen = new Set();
      displayData = displayData.filter((el) => {
        const key = el.caption || el.url;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    return (
      <div>
        {this.state.isLoaded && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {displayData
                  .length > 0 && (
                  <>
                    
                   
                      <AliceCarousel
                        responsive={{
                          0: {
                            items: 1,
                          },
                          1024: {
                            items: 4,
                            itemsFit: "contain",
                          },
                        }}
                        autoPlay={true}
                        autoWidth={true}
                        autoHeight={false}
                        autoPlayInterval={2000}
                        dotsDisabled={true}
                        buttonsDisabled={true}
                        mouseTracking
                        items={displayData
                          //.filter((el) => el.type == this.props.type)
                          .map((el, index) => {
                            return (
                              <div key={index}>
                                <img
                                  src={el.url}
                                  onDragStart={handleDragStart}
                                  role="presentation"
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "contain",
                                  }}
                                />
                               
                                <Typography
                                  style={{
                                    fontWeight: 700,
                                    fontSize: 13,
                                    lineHeight: '0.1em',
                                    marginTop: 20,
                                    textAlign: "center",
                                  }}
                                >
                                  {el.caption}
                                </Typography>
                              </div>
                            );
                          })}
                      />
                   
                  </>
                )}
              </Grid>

             

              


              
            </Grid>
          </>
        )}
      </div>
    );
  }
}
